export const cardTypeTranslation = {
  'Client::Card::Fleet': 'Frota',
  'Client::Card::Personal': 'Pessoal'
}

export const cardTypeOptions = Object.entries(cardTypeTranslation).map(([value, label]) => ({ value, label }));

